// extracted by mini-css-extract-plugin
export default {"dialog":"RemoveDialog_dialog__tt1xM","actions":"RemoveDialog_actions__iyJOI","formButton":"RemoveDialog_formButton__NdAUQ"};